// src/redux/actions/salesActions.js
import { 
    GET_ANALYTICS_FILTERS_REQUEST, 
    GET_ANALYTICS_FILTERS_SUCCESS, 
    GET_ANALYTICS_FILTERS_FAILURE 
} from '../../../../Constants/actionTypes';
import { fetchAnalyticsFilters } from '../../../../Constants/apiService'

// Fetch Sales Request Action
export const fetchAnalyticsFilterRequest = () => ({
    type: GET_ANALYTICS_FILTERS_REQUEST,
});

// Fetch Sales Success Action
export const fetchAnalyticsFilterSuccess = (salesData) => ({
    type: GET_ANALYTICS_FILTERS_SUCCESS,
    payload: salesData,
});

// Fetch Sales Failure Action
export const fetchAnalyticsFilterFailure = (error) => ({
    type: GET_ANALYTICS_FILTERS_FAILURE,
    payload: error,
});

// Thunk Action Creator for Fetching Sales
export const fetchAnalyticsFilterAct = () => {
    return async (dispatch, getState) => {
        dispatch(fetchAnalyticsFilterRequest());

        const state = getState();
        const accessToken = state.auth.accessToken; 


        try {
            const data = await fetchAnalyticsFilters(accessToken);
            console.log(data)
            dispatch(fetchAnalyticsFilterSuccess(data));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(fetchAnalyticsFilterFailure(errorMessage));
        }
    };
};
